<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
    props: {
        userRole: String
    },
    computed: {
        selfReflectionSpan() { 
            return this.userRole === 'Teacher' ? 22 : 19 
        },
        weTeachSpan() { 
            return this.userRole === 'Teacher' ? 2 : 5
        },
        header() {
            return this.userRole === 'Teacher' ? 'Self-Reflection Tool' : 'Danielson Professional Learning'
        }
    }
})

export default class SelfReflection extends Vue {
    adminHeader = {
        lineHeight: 'inherit'
    }
}
</script>

<template>
    <div class="self-reflection">
        <el-row>
            <el-col :span="selfReflectionSpan" :style="adminHeader">{{header}}</el-col>
            <el-col :span="weTeachSpan">
                <img src="../assets/images/weteach.png">
            </el-col>
        </el-row>
        <p v-if="userRole === 'Teacher'">Use <a href='https://www.weteachnyc.org/resources/resource/teacher-self-reflection-tool/' target='_blank'>this optional tool from WeTeachNYC</a> to celebrate your growth and strengthen your practice. Feel free to share your reflections with your principal, coach, a peer, or simply use it for your own personal growth. This tool along with other resources related to your practice from WeTeachNYC are found in the "WeTeachNYC" tab of Growth Explorer.</p>
        <p v-else>The resources <a href='https://www.weteachnyc.org/resources/collection/framework-teaching-professional-learning-resources' target='_blank'>in this collection</a> support administrators and teachers in using the Framework for Teaching as a tool to enhance teachers' professional practice.</p>
    </div>
</template>

<style lang="scss" scoped>

.self-reflection {
    background: #f0f0f0;
    padding: 20px;
    .el-row {
        .el-col:first-child {
            font-family: 'museo_slab', sans-serif;
            font-size: 20px;
            color: #000000;
            line-height: 39px;
        }
        .el-col:nth-child(2) {
            text-align: right;
            img {
                height: 39px;
            }
        }
    }
    p:not(:first-child) {
        font-family: 'museo_sans', sans-serif;
        font-size: 18px;
        line-height: 1.63;
    }
}

</style>